<template>
  <b-row>
    <b-col md="12">
      <b-card class="shadow-sm">
        <div class="d-flex justify-content-between align-items-center mb-1">
          <h5 class="mb-0 font-weight-bolder text-body">
            <b-icon-trophy v-if="isWinner" class="text-success" />
            <feather-icon v-else icon="TrendingDownIcon" class="text-danger" />
            Top 10 {{ isWinner ? "Winners" : "Losers" }}
          </h5>
          <b-badge
            :variant="isWinner ? 'success' : 'danger'"
            class="rounded-pill"
          >
            High {{ isWinner ? "Value" : "Risk" }}
          </b-badge>
        </div>

        <!-- Skeleton wrapper -->
        <b-skeleton-wrapper :loading="loading">
          <template #loading>
            <div class="rank-wrapper">
              <b-list-group>
                <b-list-group-item
                  v-for="n in 10"
                  :key="'skeleton-' + n"
                  class="rank-item"
                >
                  <div
                    class="d-flex align-items-center w-100 justify-content-between"
                  >
                    <div class="d-flex align-items-center">
                      <b-skeleton type="avatar" width="32px" height="32px" />
                      <b-skeleton width="120px" class="ml-2" />
                    </div>
                    <b-skeleton width="70px" />
                  </div>
                </b-list-group-item>
              </b-list-group>
            </div>
          </template>

          <!-- Actual data -->
          <div class="rank-wrapper" v-if="users.length > 0">
            <b-list-group>
              <b-list-group-item
                v-for="(item, index) in users"
                :key="item.userId || `${item.name}-${index}`"
                class="rank-item"
                :style="rankItemStyle(isWinner)"
              >
                <div class="d-flex align-items-center">
                  <RankBadge
                    :rank="index + 1"
                    :type="isWinner ? 'winner' : 'loser'"
                  />
                  <b-link :to="`/customers/view/${item.userId}`">
                    <span class="text-name text-body ml-1 font-weight-bold">
                      {{ item.name }}
                    </span>
                  </b-link>
                </div>
                <span
                  :class="[
                    isWinner ? 'text-success' : 'text-danger',
                    'font-weight-bolder',
                  ]"
                >
                  {{ isWinner ? "+" : "-"
                  }}{{
                    formatCurrencyBuiltInFunc(item.losses || item.winnings)
                  }}
                </span>
              </b-list-group-item>
            </b-list-group>
          </div>
          <div v-else class="text-center">No data available.</div>
        </b-skeleton-wrapper>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import RankBadge from "./RankBadge.vue";
import {
  BCol,
  BRow,
  BContainer,
  BCard,
  BListGroup,
  BListGroupItem,
  BBadge,
  BIcon,
  BIconTrophy,
  BSkeleton,
  BSkeletonWrapper,
  BLink,
} from "bootstrap-vue";
import { arrayProp, booleanProp } from "@/helpers/props";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";

export default {
  props: {
    users: arrayProp(),
    isWinner: booleanProp(false),
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RankBadge,
    BCol,
    BRow,
    BContainer,
    BCard,
    BListGroup,
    BListGroupItem,
    BBadge,
    BIcon,
    BIconTrophy,
    BSkeleton,
    BSkeletonWrapper,
    BLink,
  },
  methods: {
    formatCurrencyBuiltInFunc,
    rankItemStyle(isWinner) {
      return {
        "--bg-color": isWinner ? "#f0fff4" : "#fff5f5",
        "--bg-hover-color": isWinner ? "#d0fae5" : "#ffe3e3",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.rank-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--bg-color) !important;
  border: none;
  margin-bottom: 10px;
  border-radius: 8px;
  transition: background 0.2s ease;
  &:hover {
    background: var(--bg-hover-color) !important;
  }
}
</style>
